<script>
import { GlAlert, GlIcon } from '@gitlab/ui';

export default {
  name: 'PageNotFound',
  components: {
    GlAlert,
    GlIcon,
  },
};
</script>

<template>
  <div class="gl-my-9 gl-mx-11">
    <div class="gl-py-6 gl-inset-border-b-1-gray-200">
      <router-link
        to="/"
        class="gl-link gl-text-decoration-none gl-display-inline-flex gl-align-items-center"
      >
        <gl-icon
          name="arrow-left"
          title="Back"
          :size="14"
          class="gl-vertical-align-middle gl-mr-2"
        />
        Return to status overview
      </router-link>
    </div>
    <gl-alert variant="danger" :dismissible="false">
      The page requested was not found. Use the link above to see the full list of incidents.
    </gl-alert>
  </div>
</template>
